import { useContext } from 'react';
import { Formik } from 'formik';
import { CircleLoader } from 'components';
import WarehouseForm from './components';
import { warehouseContext, warehouseSchema } from './WarehouseDetailsContext';

let WarehouseDetails = () => {

    let service = useContext(warehouseContext);

    return (
            <Formik
                enableReinitialize={true}
                initialValues={service.warehouse}
                validationSchema={warehouseSchema}
                onSubmit={(values, action) => {
                    service.saveWarehouse(values);
                    action.setSubmitting(false);;
                }}
            >
                <>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false && <WarehouseForm />}
                </>
            </Formik>
    )
}

export default WarehouseDetails;